import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'

const ProtectedRoute = ({ children, permission }) => {
  const { currentUser, userProfile } = useAuth()

  if (!currentUser) return <Navigate to='/admin/login' replace />

  if (permission && userProfile?.permissions && !userProfile.permissions.includes(permission)) {
    return <Navigate to='/admin' replace />
  }

  return children
}

export default ProtectedRoute
